import { useAppSelector, useAppDispatch } from '../store/hooks';
import { logoutThunk } from '../store/middlewares/authThunk';

// ----------------------------------------------------------------------

const useAuth = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  const logout = async () => {
    await dispatch(logoutThunk());
  };

  return {
    ...auth,
    roles: auth.roles || [],
    user: {
      ...auth,
      roles: auth.roles || [],
      displayName: auth.displayName || auth.email || 'Staff',
    },
    method: 'redux',
    logout,
  };
};

export default useAuth;
